
import state from './modulePortalManagementState.js'
import mutations from './modulePortalManagementMutations.js'
import actions from './modulePortalManagementActions'
import getters from './modulePortalManagementGetters'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
